import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AdminService } from '../../services/admin.service';
import { AuthService } from 'src/app/auth-module/services/auth.service';
import dataFile from '../../../auth-module/detailed-registration/data.js'
import Swal from 'sweetalert2';

@Component({
  selector: 'app-facility-info',
  templateUrl: './facility-info.component.html',
  styleUrls: ['./facility-info.component.scss']
})
export class FacilityInfoComponent implements OnInit {
  queryParams: any;
  facilityInfo: any;
  heading = dataFile[0];       //All headings from data file
  inputDataList = dataFile[1];
  isDisableForm: boolean = true;
  userId: any;
  @Output() showSideBar = new EventEmitter();
  showSideMenu: boolean = false;

  constructor(private router: Router, private route: ActivatedRoute, private authService: AuthService) {
    this.queryParams = this.route.snapshot.queryParams;
    let q = Object.keys(this.queryParams)
    if (q.length > 0) {
      let decodedStr = atob(`${q[0]}`);
      // console.log('qq', decodedStr);
      let properties = decodedStr.split('&');
      let obj = {};
      properties.forEach(function (property) {
        let tup = property.split('=');
        obj[tup[0]] = tup[1];
      });
      this.queryParams = obj;
    }

    // console.log('after decrypted in facility info', this.queryParams);

    this.userId = this.queryParams.userId;

    this.authService.getUserDetail(this.queryParams.userId, sessionStorage.getItem("token")).subscribe((response: any) => {
      console.log('response', response.data);
      this.facilityInfo = response.data;
    })
  }

  ngOnInit(): void {
  }

  backIconClick() {
    this.router.navigateByUrl('/admin/facility-listing');
  }

  submitData(response) {
    let detailRegisterData = response[0].value;
    detailRegisterData = { ...detailRegisterData, finalSubmit: true }
    let token = sessionStorage.getItem("token");
    this.authService.detailRegisterSubmit(detailRegisterData, token).subscribe((response: any) => {
      console.log("OTP DATA", response);
      // if (response.code == 200) {
      Swal.fire('Success', 'Data Submitted Successfully', 'success').then(() => {
        this.router.navigateByUrl('admin/facility-listing');
      })

      // const dialogRef = this.dialog.open(RegisterTermsConditionComponent, {
      //   width: '500px',
      // });
      sessionStorage.setItem("facility name", detailRegisterData['facility_name']);   //To update name

    },
      (error) => {
        console.log(error.error.message);
        Swal.fire('Error', `${error.error.message}`, 'error')
      }
    )
  }

  formButtonResEvent(response) {
    console.log("inside detailed form", response);
    if (response[0].status == 'VALID') {
      // Swal.fire('Sucess', 'Form DATA is VALID', 'success')
      this.submitData(response)
      console.log('response', response);
    }
  }

  isDisableFormRes(event) {
    console.log('event in facility info', event);
    // this.isDisableForm = event;
  }

  showSideBarMenu() {
    this.showSideMenu = !this.showSideMenu;
    this.showSideBar.emit(this.showSideMenu)
  }

}
